module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“No,” Ethan Delaney said firmly. “I don’t do freelance work. You’ll have to find yourself another man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man on the other end of the line pulled out all the stops with a last-ditch effort to persuade him to reconsider. The offer jumped to a cool million.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan just shook his head. Anyone who offered that much money was likely up to no good. Especially since they wanted to keep the mission hush-hush and refused to go to the police. Retrieving a supposedly kidnapped relative from a third-world country where drugs were the number-one export was just plain asking for trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good day, Mr. Santiago,” Ethan said, then hung up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Some people just couldn’t take no for an answer. Ethan was a Colby agent. He took his assignments from one person and one person only. Victoria Colby. Of course, most of the time those orders were passed along to him by Ian Michaels, her second in command. But Ethan didn’t mind that. He liked Ian. Ethan grinned. He liked the guy’s wife even better. Nicole was really something. She worked at the Colby Agency now, as ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("well, in research mostly. Ian didn’t want the mother of his child doing fieldwork. Ethan couldn’t blame him. If he had a woman like that, he’d take good care of her, too.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that wasn’t going to happen. He would never allow himself to get that close to another human being again. Nowadays he kept things simple…uncomplicated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A light tap on his office door drew Ethan’s attention in that direction. Amy Wells smiled at him before stepping inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, Ethan,” she said as she placed a couple of reports in his inbox. She was young…very young. Only twenty-three, if memory served him right. And about as naive as they came. “Mildred asked me to drop off the reports Victoria signed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned back in his chair and gifted the Colby Agency’s receptionist with a high-voltage smile. “Good morning, Amy. I appreciate you delivering those personally.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was all it took. She blushed and immediately started to back out of his office. “Have a nice day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It would be a lot nicer if you’d agree to have lunch with me,” he suggested, knowing full well what her reaction would be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes rounded. “I—I…ah…think I’ll probably have to work right through lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head solemnly and blew out a breath as if weary of her rejections. “That’s a shame.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gotta go!” she almost squeaked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Ethan chuckled as he watched her all but fly from his ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("office. Her answer was the same every time. The kid was afraid of her shadow and considered him to be some sort of bogeyman. He loved to tease her.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The intercom on his desk buzzed and he pressed the speaker button. “Delaney here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ethan, could you come to my office, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Victoria.")]), _vm._v(" “Sure thing.” He pushed back from his desk and stood. “On my way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan left his office and strolled down the richly carpeted corridor. He winked at Amy as he passed the arched entryway that led to the vacant reception area. She abruptly looked away, color rising in her cheeks once more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elegantly appointed furnishings and tasteful decorating lent the perfect ambiance to the prestigious agency. From the moment a prospective client entered those polished mahogany doors, there was never any question as to the caliber of the staff housed here. But as on most Mondays, it was quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Colby Agency was the best in the business of private investigations and personal protection. No one even got close to matching Victoria Colby’s stellar reputation. She had clients from all over the world. She had a staff of highly qualified, handpicked investigators.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("That had been the thing that made Ethan take a second look when she had recruited him. At thirty-one, and only eight years from retirement, he’d walked away from his military career without a backward glance. He clenched his jaw, purposely pushing those thoughts aside. One year later, Victoria had wanted him on her team. At the interview, she’d said that he had come ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("highly recommended by some friend of hers who had military connections. Lucas Camp—whoever he was. Though Ethan had never met him, he knew from Victoria’s description that Camp was one of those top-secret spooks that weren’t supposed to exist. There probably weren’t more than a handful of people alive who knew who Lucas Camp was and what he did. Obviously, Victoria was one of the chosen few. Ethan only knew the rumors.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Twenty-fours hours after the first meeting between Ethan and Victoria, he had accepted her offer. The salary was outstanding, but that’s not what had sold him on the Colby Agency. Case in point, this morning’s telephone call. Not even a million dollars could buy Ethan Delaney if he didn’t want to be bought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Honesty and loyalty were the two qualities that mattered most to him. Victoria didn’t play games and she never, ever allowed herself or her people to be manipulated. Victoria Colby was the genuine article. Straight as an arrow and completely loyal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She thoroughly investigated every client who walked through those doors. Ethan didn’t have to worry about being used or set up. He intended personally to insure that that never happened again. Those haunting memories from the past tried to surface once more. He banished them instantly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was over. He couldn’t change the past. But he could damn well prevent history from repeating itself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan paused in Victoria’s doorway. She was alone. He’d fully expected to find Ian there as well. “Morning, Victoria.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good morning, Ethan. Please come in and have a seat.” She gestured to one of the two wingback chairs that flanked her desk. “I have a possible new client I’d like to discuss with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great.” Ethan settled into one of the chairs, thankful for a new assignment. He preferred to stay busy and since he’d completed his last case over a week ago, he was getting a little antsy. “I can be ready to go wherever and whenever you need me—today would be terrific.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The sooner the better,")]), _vm._v(" he almost added.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Victoria smiled. “That’s one of the things I like about you, Ethan. Your enthusiasm for your work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan nodded, acknowledging the compliment. He’d come really close to going in the other direction just before Victoria found him. Three years ago, his last military mission had almost cost him his ability to care, as well as his life. But the Colby Agency had given both back to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was whole again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the most part, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Victoria relaxed into her leather chair and studied him for a moment. It was her way. He’d gotten used to the reflective moments she indulged in. He simply sat back and enjoyed the view. She was a very attractive woman, even at fifty. Her hair was still raven, with just a few threads of gray and she had the darkest eyes. The kind that could see right through to the heart of things. Honest eyes. That lovely face, however, was not without its share of hard-earned lines. Lines that spoke of experience and loss.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Though Ethan didn’t know the whole story, he’d ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("heard the talk. Victoria’s husband had been murdered. That devastating event had come only five years after the loss of her seven-year-old son. She never talked about that either. Only two people knew the whole story—Mildred, her personal secretary, assistant really, and Trevor Sloan, a former Colby investigator. But everyone had heard the talk.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Victoria Colby had suffered more than her fair share of pain. But it seemed only to make her stronger…more determined to make the world right in any way she could.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure you’re familiar with Ballard Pharmaceuticals, better known as BalPhar, down in Aurora.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan recognized the name. “They’re one of our long-term clients.” The company was well known for its headline-making research, he recalled. When it came to pioneering new drugs, BalPhar was a leader in the industry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Colby Agency has done business with Austin Ballard for more than ten years,” Victoria went on. “We’ve done the background clearance on all his employees and the occasional investigation into companies with whom they were considering doing business. I have a great deal of respect for Austin. That’s the main reason I’m considering taking this case in spite of the suspicious circumstances.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought Simon took care of BalPhar’s work,” Ethan countered. Simon Ruhl was former FBI. No one was better at digging up dirt on people and companies than Simon. Ethan definitely didn’t want to horn in on his territory.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s true, but he’s on an assignment that he can’t break away from at the moment. I believe that time is of the essence where this case is concerned.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan frowned. That sounded a little ominous. “What’s the deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Austin has a twenty-two-year-old daughter, Jennifer. She’s something of a genius. Graduated high school by thirteen, had her doctorate by the time she was eighteen. She’s worked side by side with her father since she was a child. Every moment she wasn’t in school, she was in a lab.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan immediately pictured big, thick eyeglasses and hair pulled into a bun. Oh yeah, and the proverbial white lab coat. “She sounds like an interesting lady.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To a microscope,")]), _vm._v(" he added to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A tiny smile disrupted Victoria’s usually all-business expression. “I’m sure you’ll find her most interesting, especially under the circumstances.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged. “So what’s her problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She thinks someone is trying to kill her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blunt statement jerked Ethan to a higher level of attention. “Someone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She believes the threat to her life is coming from inside her father’s company.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A frown nagged at Ethan. “What does her father say about it?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("“He’s gravely ill,” she explained. “His medical problem started more than a year ago. But about six months ago he became bedridden. My understanding of his current condition is that he drifts in and out of a ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("catatonic state. He may not even be aware of his daughter’s claims.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s Miss Ballard now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In hiding. She gave me a location where she can be found. She’d like to meet with someone as soon as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The skepticism in Victoria’s voice was impossible to miss. “You don’t trust her?” Ethan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Victoria sighed. “I don’t know her. My contact prior to this has been strictly with her father. We have a couple of news clippings of her with her father in the file, none of which are very good pictures. A little too fuzzy. But there is one photograph that was taken five years ago. Austin has kept her pretty much shielded from the press. She is his only child and he’s been more than a little overprotective. Which, in that cutthroat business, makes a great deal of sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Something doesn’t sit right with you,” Ethan suggested. He could sense her hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Victoria considered his statement for a moment. “This agency has investigated every single employee at BalPhar. They’re all clean. Of course that doesn’t mean that one hasn’t gone bad.” She paused and chose her words carefully when she spoke once more. “I think my hesitation has more to do with the daughter’s past and her reluctance to share details than with anything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan lifted an eyebrow. “Now you’ve really got my interest.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“As I said before,” Victoria went on. “She’s brilliant. But with that level of brilliance come other prob")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("lems. Social, sometimes emotional. She’s led a very sheltered life. I remember there was a problem in her final semester of undergraduate school. A breakdown of some sort. It didn’t last long and probably had more to do with her young age than anything else. According to Austin she was back on her feet and ready to dive into graduate courses in no time. But still, with the continued decline in his health, this new development gives me pause.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan could see what she meant. If the lady had any history of emotional instability, then the weight of her father’s illness might be more than she could bear. “Is she running the company in his absence?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Victoria sighed. “Yes. She’s senior vice president. A breakdown on her part could be disastrous for BalPhar during this critical time. The shareholders and benefactors Austin has worked a lifetime to develop will be monitoring every move she makes very closely. Do you see my concern?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I definitely do. That’s a lot of responsibility for someone so young, genius or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Exactly.” Victoria shook her head. “And, if I had my guess, emotionally and socially she’s far younger than twenty-two. I’m relatively certain she hasn’t led a typical lifestyle in any sense of the word.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something Victoria had said nagged at Ethan. “You said senior vice president, is there more than one?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” Victoria hastened to explain. “I ran a brief check on the company’s current status this morning. Dr. David Crane is the second vice president. As Austin’s daughter, Jennifer outranks him, of course.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("David Crane.")]), _vm._v(" Ethan knew a moment of disbelief. The kind a guy felt when he thought he’d seen a ghost. Crane was a ghost, all right. One straight from Ethan’s past.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What does Crane say about all this?” he asked hesitantly. Flashes of memory slashed through his brain. Gunfire erupting, running, death hot on their heels. He blinked the images away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Victoria eyed him curiously, noting his brief distraction. She never missed a thing. “I haven’t spoken with Dr. Crane. I promised Jennifer that I would not contact anyone at the company or the local authorities until we’d looked into her accusations. Which, of course, we can’t actually do until she gives us more details and Jennifer won’t do that until she’s met with you face-to-face.” Victoria inclined her head and studied Ethan for another moment. “Do you know Dr. Crane?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan considered saying no, but he wouldn’t lie to his boss. Avoiding the truth was something he only did when absolutely necessary. “I knew him. In another lifetime.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Should we be suspicious of him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan shook his head. “I don’t think so. He saved my life in Iraq. He seemed a pretty straight arrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see. He was in the military at the same time as you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” Ethan said, still distracted by this unexpected development. “He was a scientist being held hostage. I went in to retrieve him. On the way out, he watched my back, kept me from taking a bullet.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("“Perhaps I should ask someone else to look into this ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("case then,” she offered. “I don’t want anything getting in the way of objectivity. If there’s any chance Jennifer is right in her claims, Crane may come under suspicion.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan put up his hands, stop-sign fashion. “Don’t sweat it. Crane and I haven’t seen each other in nearly a decade. Besides, we don’t even know that Miss Ballard thinks he’s involved. But, even if he is, ancient history won’t color my judgment, I can assure you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Several tense seconds ticked by while Victoria weighed his words. Caution was her first line of defense. “All right,” she said, finally relenting. “But if your past with Crane gets in the way, I expect you to bow out gracefully.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s reasonable,” he allowed. “What do you want me to do?” The girl sounded like she needed help, and things could definitely get sticky whether Crane was involved or not. Ethan would have to evaluate the situation closely before coming to any kind of conclusions. The reputation of a pharmaceuticals company was fragile. One wrong move and years of research, not to mention millions of dollars, could end up down the drain. New, badly needed drugs could be delayed in reaching those who needed them now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s given me the name of a motel in Kankakee, a small town about fifty miles south of Chicago. I want you to talk to her. Determine if there’s any possibility that her claims are valid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And if they aren’t?” Ethan had to know what was expected of him if the girl had gone around the bend.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("“Check out her story and if it’s clear to you that she’s ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("unstable, then somehow we’ll have Dr. Melbourne take a look at her before we do anything else. I don’t want to risk bad press unnecessarily. With Austin’s illness already a matter of public knowledge, this sort of thing could ruin all that he’s worked for.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What if she doesn’t want to see Melbourne?” Ethan remembered the doc well from his prehiring interviews. The guy was a genius himself. If there was anything even slightly off-kilter, he’d find it. Melbourne was good—the best.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, then we’ll just have to find a way to convince her.” Victoria looked him straight in the eye. “Discounting what you’ve just told me about your past with Crane, I chose you for this mission for two reasons, Ethan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He held that all-knowing gaze and waited for her to continue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If there is any truth to her accusations, I want her protected at all costs. I won’t take any chances with Austin’s daughter. Secondly, your powers of persuasion where the ladies are concerned have not gone unnoticed. I’m certain you can convince Miss Ballard to see things your way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan grinned. “I’ll do my best.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure you will.” Victoria leaned forward and handed him a folded piece of paper. “That’s the location. I’m to call her at the number she left and let her know whom to expect. She would like to meet with you at one o’clock this afternoon. Does that give you time to prepare?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“I can handle it.” It was nine a.m. He’d have plenty ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("of time to go by his apartment and pick up a few things just in case this assignment took more than twenty-four hours. He tucked the note into his pocket. “I’ll call you the moment I have anything to report.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very good.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan headed to the door, mentally making a list of what he would need.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just one more thing,” Victoria called behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He paused at the door and looked back. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Since I don’t know Jennifer personally, there’s always the chance that this young woman is an impostor attempting to cause trouble for BalPhar. Maybe a disgruntled ex-employee seeking revenge. She could be a threat to security.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s possible,” Ethan agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whatever you discover, do not let this woman out of your sight. If she’s Jennifer Ballard, I want her protected. If she’s not, I want to ensure she represents no threat to the real Jennifer. We’ll need to inform BalPhar security as soon as there are any firm facts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t let anything happen to her either way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan left Victoria’s office with uneasiness twisting in his gut. Something about this whole thing didn’t feel right. Victoria felt it, too, that was the reason for the extra precautions. A dread, at once familiar and disconcerting, filtered through him. He’d been in this kind of situation where there were far too many variables once before. That situation had ended badly and almost cost him his life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("He wouldn’t let his guard down this time. No matter how sweet or innocent Jennifer Ballard appeared, she ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("was not to be trusted until he was absolutely certain it was safe to do so.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would have to prove to him beyond a shadow of a doubt that she was telling the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("Y TWELVE-THIRTY")]), _vm._v(" Ethan parked in front of the office at the Blue Moon Motel on the outskirts of Kankakee. It was a quaint joint to say the least. It reminded him of the kind of place hookers took their johns. If the esteemed Dr. Ballard had been looking for a low profile, she’d found it in a big way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan emerged cautiously from his vehicle. As he repositioned the gun at the small of his back, he surveyed the empty parking area as well as the row of vacant-looking, rundown rooms on either side of the office. The sign proclaiming Vacancies hung at an odd angle near the door. Faded blue paint was cracked and peeling from the antiquated wood siding. It was a real dump.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still scanning warily, Ethan walked up the steps and across the small porch that led to the office. The July humidity was sweltering. Inside, the office proved no cooler. A small oscillating fan kept the fetid air moving, but did nothing to cool the temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A short, bald man with a cigarette dangling from one corner of his mouth dragged his attention from the soap opera he was watching on the small television set. “Can I help you?” he asked with absolute disinterest. He didn’t even bother to rise from his dilapidated chair.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Ethan narrowed his gaze and set his lips in a grim line, a practiced move that boasted of the impatience ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("radiating behind the expression and should serve to motivate the listless clerk. “I certainly hope so.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The guy appeared startled then. He shot to his feet. It was almost as if he’d looked at Ethan for the first time and noted what could only be called trouble. Ethan knew he presented a somewhat dangerous persona, and that was fine by him, especially at times like this. It allowed for a certain ease in getting what he wanted. He could well imagine what the guy behind the scarred counter thought at the moment. Ethan’s shoulder-length hair was tied back in a queue. A small silver hoop embellished one ear. But it was his size more than anything else that served as the most persuasive. He was six-four and weighed a muscular 220 pounds. Not too many people willingly messed with him. And that’s the way he liked it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If the now-flustered clerk didn’t stop gaping Ethan was pretty sure the lit cancer stick was going to fall right out of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I need a room. My name is Ethan Delaney. I hope I don’t need a reservation.” He said the last a bit facetiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clenching his lips together to grip the cigarette, the guy shook his head, then abruptly changed it to a nod. “You…you already have a room,” he stammered. He grabbed a key. “One fourteen.” He angled his head to his left. “All the way at the end.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Ethan wasn’t surprised. Dr. Jennifer Ballard, if that was who she really was, was supposed to be waiting for him. She certainly wouldn’t risk using her real name ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("if she was in hiding. He supposed that was the reason she’d used his.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you,” he said as he reached for the key.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man behind the counter swallowed hard as he dropped the key into Ethan’s hand. “Just…just let me know if you need anything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just one thing,” Ethan said pointedly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The guy jumped. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan dropped a couple of bills on the counter. “I haven’t been here, got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The clerk’s head bobbed up and down as he pocketed the money. “Never saw you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ethan smiled, something several degrees shy of pleasant. “Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the clerk said, room 114 was all the way at the end. The six rooms before it appeared empty, just as Ethan had suspected when he arrived. He had no doubt that the seven rooms on the other side of the office were just as empty. Glancing from right to left once more, he reached for his gun and simultaneously shoved the key into the lock. He pushed open the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To his surprise it was dark inside, but blessedly cool. The drapes were pulled tight. He felt for the light switch but a distinctly feminine voice stopped him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Close the door first.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Moving into defensive mode, Ethan closed the door behind him and tightened his fingers on the weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now you can turn on the light.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He flipped the switch, blinked once to focus, his gun leveled in the direction of the sound of her voice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("A woman who looked no older than seventeen or ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("eighteen, clad in tattered hip-hugger jeans and a cut-off T-shirt stood on the opposite side of the room. She wasn’t very tall, five-two maybe, and waif-thin. Long blond hair, pale blue eyes, elfin features. Ethan couldn’t say for sure if she was Dr. Jennifer Ballard or not, but she definitely resembled the girl in the five-year-old photograph he’d seen. With one major exception—this woman was holding on tight with both hands to a small-caliber handgun, the barrel pointed at his chest.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I need to see some identification, Mr. Delaney.” She moistened her lips and exhaled a shaky breath. “But first, I’ll need you to put your gun down.”")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page29"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8173598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426871689_ch01.vue
// module id = 84
// module chunks = 0